import CreditCardComparator from '../../views/card-comparator/CreditCardComparator'

export default [
    {
        path: '/cartao-de-credito/comparar/:slugs?',
        name: 'credit-card.compare',
        component: CreditCardComparator,
    }
]
